import React, { Component, PropTypes } from 'react';
import * as SiteApi from 'saas/sites/api';
import * as ContactApi from 'saas/contacts/api';
import SegmentLoader from 'common/components/SegmentLoader';
import SiteContactSelector from 'saas/pco/cases/form/components/SiteContactSelector';

class App extends Component {
  constructor(props, context) {
    super(props);

    this.state = {
      isFetching: false,
      sites: [],
      contacts: [],
      selectedContact: '',
      selectedSite: '',
    };
  }

  componentDidMount() {
    this._fetchCustomer(this.props.customer);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.customer !== nextProps.customer) {
      this._fetchCustomer(nextProps.customer);
    }
  }

  _fetchCustomer(customer) {
    this.setState({ isFetching: true });
    Promise.all([
      SiteApi.getByCustomer(customer),
      ContactApi.getByCustomer(customer),
    ]).then(responses =>
      this.setState({
        sites: responses[0],
        contacts: responses[1],
        isFetching: false,
      })
    );
  }

  onSiteAdded = site =>
    this.setState(
      {
        sites: [...this.state.sites, site],
        selectedSite: site.id.toString(),
      },
      this.props.onSiteSelected
    );

  onSiteSelected = site => {
    if (site === '') {
      this.setState(
        {
          selectedSite: '',
        },
        this.props.onSiteUnselected
      );
    } else {
      this.setState(
        {
          selectedSite: site,
        },
        this.props.onSiteSelected
      );
    }
  };

  onContactAdded = contact =>
    this.setState(state => ({
      contacts: [...state.contacts, contact],
      selectedContact: contact.id.toString(),
    }));

  onContactSelected = contact => {
    this.setState({
      selectedContact: contact,
    });
  };

  render() {
    const { customer } = this.props;
    const {
      isFetching,
      sites,
      selectedSite,
      contacts,
      selectedContact,
    } = this.state;

    if (isFetching) {
      return <SegmentLoader />;
    }

    return (
      <div>
        {selectedSite && (
          <input type="hidden" name="siteId" value={selectedSite} />
        )}
        {selectedContact && (
          <input type="hidden" name="contactId" value={selectedContact} />
        )}
        <SiteContactSelector
          customer={customer}
          sites={sites}
          contacts={contacts}
          selectedSite={selectedSite}
          selectedContact={selectedContact}
          onSiteAdded={this.onSiteAdded}
          onSiteSelected={this.onSiteSelected}
          onContactAdded={this.onContactAdded}
          onContactSelected={this.onContactSelected}
        />
      </div>
    );
  }
}

App.propTypes = {
  customer: PropTypes.string.isRequired,
  onSiteSelected: PropTypes.func.isRequired,
  onSiteUnselected: PropTypes.func.isRequired,
};

App.childContextTypes = {
  customer: PropTypes.string.isRequired,
};

export default App;



// WEBPACK FOOTER //
// ./src/modules/saas/demands/fast/App.js